<template>
  <pool title="在编情况" @chooseCount="chooseCount" :dataList="showDataList" :countList="countList" v-loading="loading"></pool>
</template>

<script>
import {
  loadDetail,
  detailFilter,
  getCountData
} from './lib'

import pool from './pool'
export default {
  data () {
    return {
      dataList: [],
      searchParm: {
        type: null
      },
      loading: false
    }
  },
  components: {
    pool
  },
  computed: {
    typeList () {
      return ['在编', '非在编'].map(v => {
        return {
          name: v
        }
      })
    },
    showDataList () {
      return this.dataList.filter(v => detailFilter(v, this.searchParm))
    },
    countList () {
      let data = getCountData(this.dataList, this.typeList, 'type', '未配置')
      data.forEach(v => v.active = this.searchParm.type === v.key)
      return data
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    chooseCount (cIndex) {
      let type = this.countList[cIndex].key
      if (this.searchParm.type === type) {
        this.searchParm.type = null
      } else {
        this.searchParm.type = type
      }
    },
    async loadData () {
      this.loading = true
      this.dataList = await loadDetail(this)
      this.loading = false
    }
  }
}
</script>
